module.exports = __webpack_public_path__ + "static/printer-ba30f9eef55938a27745306240535fbd.png";